import React from 'react'

import PageHeader from '../components/world-of-data/PageHeader'
import Grid from '../components/world-of-data/Grid'
import Layout from '../components/common/Layout'

const ExplorePage = ({ pageContext }) => {
  const title = pageContext.title
  const pages = pageContext.data
  const isMainPage = title === 'World of Data'
  const isCountries = title === 'countries'
  return (
    <Layout
      title={isMainPage ? 'World of Data' : `Explore ${title} of the world`}
      meta={{
        description:
          'Explore the world of data with Atlas. Discover the most interesting spatial data and maps from around the world.',
        title: isMainPage
          ? 'World of Data | Atlas'
          : `Explore ${title} of the world | Atlas`,
        absoluteImageUrl: 'https://atlas.co/images/world-of-data.png',
        type: 'website'
      }}
    >
      <main>
        <PageHeader title={title} />

        <Grid
          pages={pages}
          category={isMainPage ? '' : title}
          isCountries={isCountries}
        />
      </main>
    </Layout>
  )
}

export default ExplorePage
